import { render } from "./GlobalModals.vue?vue&type=template&id=48f1e745"
import script from "./GlobalModals.vue?vue&type=script&lang=js"
export * from "./GlobalModals.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__